import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Logo } from '../logo'
import { Connection } from './Connection'
import { Navigation } from '../Navigation'
import { Colors } from '../../constants'

export function TopBar() {
  return (
    <Bar>
      <NavLinkStyled to="/">
        <LogoStyled />
      </NavLinkStyled>
      <Navigation />
      <ConnectionStyled />
    </Bar>
  )
}

const Bar = styled.header`
  padding: 12px 300px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #5a709c3c;

  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    content: '';
    border-top: 1px solid #2c2f35;
  }

  @media (max-width: 1024px) {
    padding: 12px 24px;
  }
`

const NavLinkStyled = styled(NavLink)`
  display: flex;
  position: absolute;
  left: 24px;
  align-items: center;
  flex-shrink: 0;
`

const LogoStyled = styled(Logo)`
  width: 136px;
  height: 36px;
  color: ${Colors.White};

  @media (max-width: 1024px) {
    width: 22px;

    svg {
      &:first-child {
        flex-basis: 100%;
      }

      &:last-child {
        display: none;
      }
    }
  }
`

const ConnectionStyled = styled(Connection)`
  position: absolute;
  right: 24px;

  @media (max-width: 1024px) {
    padding: 0 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 54px;
    border-radius: 0;
    z-index: 1;
  }
`
